export default __webpack_public_path__ + "static/media/Cloud.471b87c1.svg";